<template>
<div :style="columnMargin" class="swiper-y">
  <van-swipe class="my-swipe" :autoplay="3000" :style="swiperStyle" vertical :show-indicators="false" :touchable="false">
    <van-swipe-item @click="doLocationHref(swipeItem)" v-for="(swipeItem,swipeIndex) in item.adList" :key="swipeIndex">
      <div class="swiper-y-text">{{swipeItem.adDesc}}</div>
    </van-swipe-item>
  </van-swipe>
</div>
</template>

<script>
export default { 
  name: 'SwiperY',
  data() {
    return {
      current: 0
    }
  },
  props: {
    item: Object,
  },
  components: {
    
  },
  created() {
  },
  watch: {
  
  },
  computed: {
    swiperStyle(){
      var obj = {}
      obj['height'] = '27px'
      obj['font-size'] = '14px'
			return obj
    },
    columnMargin(){
      var self = this
      var obj = {}
      if(self.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
      self.item.styleObj.bgColor && (obj['background'] = self.item.styleObj.bgColor);
      self.item.styleObj.textColor && (obj['color'] = self.item.styleObj.textColor);
			return obj
    }
  },
  methods: {
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
  }
}
</script>

<style scoped>
.swiper-y{
  width: 355px;
  padding: 0 10px;
  margin-top: 10px;
  overflow: hidden;
}
.swiper-y-text{
  height: 27px;
  line-height: 27px;
  white-space: normal;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>